import { Component } from '@angular/core';

import { NavController, Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { UserService } from './user.service';
import { FCM } from 'plugins/cordova-plugin-fcm-with-dependecy-updated/ionic/ngx/FCM';
import { Globals } from './globals';
import { CartService } from './cart.service';
import * as CryptoJS from 'crypto-js';
import { Device } from '@ionic-native/device/ngx';
import { RestService } from './rest.service';
import { Storage } from '@ionic/storage-angular';


declare const cordova: any;
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private fcm: FCM,
    private splashScreen: SplashScreen,
    private user: UserService,
    private statusBar: StatusBar,
    private clave: Globals,
    private cart: CartService,
    private device:  Device,
    private nav: NavController,
    private rest: RestService,
    private storage: Storage,
    private service: CartService

  ) {
    this.storage.create()
    this.initializeApp()
   }

  async initializeApp(){
    let platform  = this.device.platform;
    if (platform) {
      localStorage.removeItem('cart');
      localStorage.removeItem('commerce');
      localStorage.removeItem('TotalPrice');
      this.service.total = 0;
      this.service.cart = [];  
    }
    
    let objetoInicial = {
      address: "",
      district: null,
      door: "",
      id_address: "",
      lat: "",
      lng: "",
      number: "",
      postal_code: "",
      primary: "",
      state: "",
      user_id: ""
    }
    
    //this.storage.set('actual_address', objetoInicial);
    

    let commerce
    let cartObj

    let tieneStorageLog = (await localStorage.getItem('log') === 'true')
    
    if (localStorage.getItem('cart') != '') {
      cartObj=await localStorage.getItem('cart')
    }
    let totalPrice=await localStorage.getItem('TotalPrice')
    if (localStorage.getItem("commerce") != null) {
      commerce=await localStorage.getItem('commerce')
    }
    
    if((document.URL.startsWith('http') || document.URL.startsWith('https')) && tieneStorageLog){

      this.user.isLoggedIn=true
      if (localStorage.getItem('user') !== null) {
        try {
          let data=await localStorage.getItem('user');
          data=CryptoJS.AES.decrypt(data,this.clave.secret).toString(CryptoJS.enc.Utf8);
          this.user.data=JSON.parse(data);
          this.GetAdresses2();
          console.log('bien cifrado')
        } catch (error) {
          localStorage.removeItem('TotalPrice')
          localStorage.removeItem('cart')
          localStorage.removeItem('commerce')
          localStorage.removeItem('user')
          localStorage.setItem('log', 'false')
          localStorage.setItem('lastURL', '')

          this.user.resetAuth();
          this.nav.navigateRoot('tabs/tab1');
          this.user.isLoggedIn = false;
          this.user.data.token = '';
          console.log('mal cifrado');
        }
        
      }
      
      if(cartObj!=null && totalPrice!=null){
        this.cart.cart=JSON.parse(cartObj)
        this.cart.total=parseFloat(totalPrice)
        if (commerce != null) {  
          this.cart.Commerce=JSON.parse(commerce)
        }
        
      }
    }else {
      this.platform.ready().then(() => {
      this.user.getAuth2().then((data) => {
        //console.log(this.user.isLoggedIn)
        //console.log('ESTAAAAAA LOGUEADOOOOOOO123456789123456789')
        this.GetAdresses2();
      });
      
      /* if (this.user.isLoggedIn) {
        console.log('ESTAAAAAA LOGUEADOOOOOOO')
        this.GetAdresses2();
      } */
      
      this.fcm.requestPushPermission()
      .then( (permission) => {
        this.fcm.getToken().then(token => {});
      })
      .catch((err) => {} );

      this.fcm.hasPermission()
      .then(hasPermission => {if (hasPermission) {} });

      this.fcm.subscribeToTopic('test123')
        .then( () => console.log('suscrito a test123') )
        .catch( (error) => console.log('[ERROR]subscribeToTopic test123' + JSON.stringify(error) ) );

      this.fcm.subscribeToTopic('all')
      .then( () => console.log('suscrito a all') )
      .catch( (error) => console.log('[ERROR]subscribeToTopic ALL' + JSON.stringify(error) ) );

      
      this.fcm.onNotification().subscribe(
      (data) => { 
        /* if (data.wasTapped){} else {}  */
      });

      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
    }
    
  }

  askTrackingPermission() {
      /*if (this.platform.is('ios')) {
        if (window.cordova) {
          window.cordova.exec(win, fail, 'idfa', "requestPermission", []);
        }
      }
      function win(res) {}
      function fail(res) {}*/
  }

  readTrackingPermission() {
      /*if (this.platform.is('ios')) {
        if (window.cordova) {
          window.cordova.exec(win, fail, 'idfa', 'getInfo', []);
        }
      }
      function win(res) {}
      function fail(res) {}*/
  }

  TrackingPermission(){
    
      const idfa = cordova.plugins.idfa;

      idfa.getInfo()
      .then(info => {
          if (!info.trackingLimited) {
              return info.idfa || info.aaid;
          } else if (info.trackingPermission === idfa.TRACKING_PERMISSION_NOT_DETERMINED) {
              return idfa.requestPermission().then(result => {
                  if (result === idfa.TRACKING_PERMISSION_AUTHORIZED) {
                      return idfa.getInfo().then(info => {
                          return info.idfa || info.aaid;
                      });
                  }
              });
          }
      })
      .then(idfaOrAaid => {
          if (idfaOrAaid) {
          }
      });
  }


  /* GetAdresses(){
    this.rest.getAdress().subscribe(
      async data => {
        this.user.adressesUser = data['data'];
      },
      (error) => this.user.generateToast(error.error.message));
  } */

  async GetAdresses2(){
    await this.rest.getAdress2()
    .then((data) => {
      this.user.adressesUser = data['data'];
    })
    .catch((error) => {
      console.error(error);
    })
    /* this.rest.getAdress().subscribe(
      async data => {
        this.user.adressesUser = data['data'];
      },
      (error) => this.user.generateToast(error.error.message)); */
  }








  /*
  
  ⢀⡴⠑⡄⠀⠀⠀⠀⠀⠀⠀⣀⣀⣤⣤⣤⣀⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠸⡇⠀⠿⡀⠀⠀⠀⣀⡴⢿⣿⣿⣿⣿⣿⣿⣿⣷⣦⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠑⢄⣠⠾⠁⣀⣄⡈⠙⣿⣿⣿⣿⣿⣿⣿⣿⣆⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⢀⡀⠁⠀⠀⠈⠙⠛⠂⠈⣿⣿⣿⣿⣿⠿⡿⢿⣆⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⢀⡾⣁⣀⠀⠴⠂⠙⣗⡀⠀⢻⣿⣿⠭⢤⣴⣦⣤⣹⠀⠀⠀⢀⢴⣶⣆
⠀⠀⢀⣾⣿⣿⣿⣷⣮⣽⣾⣿⣥⣴⣿⣿⡿⢂⠔⢚⡿⢿⣿⣦⣴⣾⠁⠸⣼⡿
⠀⢀⡞⠁⠙⠻⠿⠟⠉⠀⠛⢹⣿⣿⣿⣿⣿⣌⢤⣼⣿⣾⣿⡟⠉⠀⠀⠀⠀⠀
⠀⣾⣷⣶⠇⠀⠀⣤⣄⣀⡀⠈⠻⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⡇⠀⠀⠀⠀⠀⠀
⠀⠉⠈⠉⠀⠀⢦⡈⢻⣿⣿⣿⣶⣶⣶⣶⣤⣽⡹⣿⣿⣿⣿⡇⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠉⠲⣽⡻⢿⣿⣿⣿⣿⣿⣿⣷⣜⣿⣿⣿⡇⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⢸⣿⣿⣷⣶⣮⣭⣽⣿⣿⣿⣿⣿⣿⣿⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⣀⣀⣈⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⠇⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⢿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⠃⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠹⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⡿⠟⠁⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠉⠛⠻⠿⠿⠿⠿⠛⠉

  */

}
